'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FieldDescription = forwardRef(function FieldDescription(rest, ref) {
    return jsx("div", { "data-field": 'description', ref: ref, ...rest });
});

export { FieldDescription };
